module.exports = __webpack_public_path__ + "media/components/country-flag/static/np-1948ac08615400050ddd958969ce3c10.svg";